<mat-expansion-panel class="job-item__expansion-panel mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="job-item__header">
        <div class="job-item__header-title-container">
          <div>
            <span class="job-item__header-title">
              @if (message.result_object?.task_name_override) {
                {{ message.result_object.task_name_override }}
              }
              @else {
                {{ message.task_name | translate }}
              }
            </span>

            <span>
              {{ message.fileTypeName }}
            </span>
          </div>

          <div>
            <span class="job-item__header-subtitle">
              {{ message.taskMetaData }}
            </span>
          </div>
        </div>

        <div class="job-item__header-status">
          @switch (message.statusType) {
            @case ('active') {
              <mat-spinner
                diameter="20"
              />
            }
            @case ('failed') {
              <mat-icon class="job-item__icon job-item__icon--failed">
                close
              </mat-icon>
            }
            @case ('finished') {
              <mat-icon class="job-item__icon job-item__icon--finished">
                done
              </mat-icon>
            }
          }

          @if (message.statusType === 'failed') {
            <a>
              <span>{{ 'TRANS__JOB_STATUS__FAILED' | translate }}</span>
            </a>
          }
          @else if (message.statusMessage === 'step complete') {
            <span>
              {{ 'TRANS__OPERATION__' + message.statusMessage.replaceAll(' ', '_').toUpperCase() | translate }}
            </span>
          }
          @else {
            <span>
              {{ message.statusMessage }}
            </span>
          }
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div>
    @if (message.task_type === 'reports' && (message.status === 'finished' || message.status === 'downloaded')) {
      <button
        mat-stroked-button
        (click)="downloadReport(message.queue_id, message.filetype)"
      >
        <span>
          {{ 'TRANS__JOB_STATUS__DOWNLOAD' | translate }}
        </span>
      </button>
    }
    @else if (message.progress === 100 && message.result_object?.report_id && message.result_object?.dms_id) {
      <button
        mat-stroked-button
        (click)="downloadReportV2(message.result_object.report_id)"
      >
        <span>
          {{ 'TRANS__JOB_STATUS__DOWNLOAD' | translate }}
        </span>
      </button>
    }
    @else if (message.ref) {
      <a
        mat-stroked-button
        color="primary"
        queryParamsHandling="merge"
        [routerLink]="primusStateMapperService.routerLinkFromState(message.ref)"
        [queryParams]="primusStateMapperService.queryParams(message.refParams)"
      >
        <span>
          {{ 'TRANS__JOB_STATUS__OPEN' | translate }}
        </span>
      </a>
    }
    @else if (message.status === 'failed' && message.error_message?.startsWith('TRANS__')) {
      <span>
        {{ message.error_message | translate }}
      </span>
    }

    @if (featureFlagsService.getFeatureFlags().temporary.metaOperationObjectQueue) {
      <div class="job-item__id-button-container">
        <span class="job-item__body-id">
          ID: {{ message.queue_id }}
        </span>

        @if (message.statusType === 'active' && (message.status === 'in progress' || message.status === 'queued' || message.status === 'running')) {
          <button mat-stroked-button (click)="stopJob()">
            {{ 'TRANS__JOB_STATUS__STOP_JOB' | translate }}
          </button>

        }
        @else if (message.status === 'stopped') {
          <div>
            <button mat-flat-button (click)="continueJob()">
              {{ 'TRANS__JOB_STATUS__CONTINUE_JOB' | translate }}
            </button>

            <button mat-stroked-button (click)="cancelJob()">
              {{ 'TRANS__JOB_STATUS__CANCEL_JOB' | translate }}
            </button>
          </div>
        }
        @else if (message.status === 'operation complete' || message.status === 'step complete' || message.status === 'failed') {
          <div>
            <button mat-flat-button (click)="displayJobDetails()">
              {{ 'TRANS__JOB_STATUS__DISPLAY_DETAILS' | translate }}
            </button>
            <button mat-stroked-button (click)="deleteJob()">
              {{ 'TRANS__JOB_STATUS__DELETE_JOB' | translate }}
            </button>
          </div>
        }
      </div>

      @if (message.details) {
        <div class="job-item__details">
          <span class="job-item__details-title">
            {{ 'TRANS__JOB_STATUS__DETAILS' | translate }}
          </span>

          @if (message.details.has_operation_step_objects) {
            <div class="job-item__details-content">
              <div class="job-item__details-row">
                <span>
                  {{ 'TRANS__JOB_STATUS__OBJECT_COUNT' | translate }}:
                </span>

                <span>
                  {{ message.details.object_count }}
                </span>
              </div>

              <div class="job-item__details-row">
                <span>
                  {{ 'TRANS__JOB_STATUS__UNFINISHED_COUNT' | translate }}:
                </span>

                <span>
                  {{ message.details.in_progress_count }}
                </span>
              </div>

              <div class="job-item__details-row">
                <span>
                  {{ 'TRANS__JOB_STATUS__RESTRICTED_COUNT' | translate }}:
                </span>

                <span>
                  {{ message.details.object_restricted_count }}
                </span>
              </div>

              <div class="job-item__details-row">
                <span>
                  {{ 'TRANS__JOB_STATUS__PROCESSED_COUNT' | translate }}:
                </span>

                <span>
                  {{ message.details.object_processed_count }}
                </span>
              </div>

              <div class="job-item__details-row">
                <span>
                  {{ 'TRANS__JOB_STATUS__FAILED_COUNT' | translate }}:
                </span>

                <span>
                  {{ message.details.failed_count }}
                </span>
              </div>
            </div>

            <br>

            <!-- Show object indexes -->
            <div class="job-item__details-row">
              <span>
                {{ detailsStartIndex + 1 }} - {{ getEndIndex() }}
              </span>
            </div>
            <!-- Button for setting details status type -->
            <div class="job-item__details-row">
              <button
                mat-stroked-button
                (click)="setDetailsStatusType(null)"
                [disabled]="!message.details.failed_count && !message.details.in_progress_count"
              >
                {{ 'TRANS__JOB_STATUS__SHOW_ALL_OBJECTS' | translate }}
              </button>

              <button
                mat-stroked-button
                (click)="setDetailsStatusType('failed')"
                [disabled]="!message.details.failed_count"
              >
                {{ 'TRANS__JOB_STATUS__SHOW_FAILED_OBJECTS' | translate }}
              </button>

              <button
                mat-stroked-button
                (click)="setDetailsStatusType('in progress')"
                [disabled]="!message.details.in_progress_count"
              >
                {{ 'TRANS__JOB_STATUS__SHOW_IN_PROGRESS_OBJECTS' | translate }}
              </button>

              <button
                mat-stroked-button
                (click)="setDetailsStatusType('running')"
                [disabled]="!message.details.in_progress_count"
              >
                {{ 'TRANS__JOB_STATUS__SHOW_RUNNING_OBJECTS' | translate }}
              </button>

              <!-- Retry all if there are any failed objects or objects in progress -->
              <button
                mat-stroked-button
                (click)="retryJob()"
                [disabled]="retryingAll || (!message.details.failed_count && !message.details.in_progress_count)"
              >
                {{ 'TRANS__JOB_STATUS__RETRY_ALL_OBJECTS' | translate }}
              </button>
            </div>

            @for (objectStatus of message.details.object_statuses; track objectStatus.queue_index) {
              <div class="job-item__details-row">
                <!-- Can retry if the status is 'failed' or 'in progress' -->
                <button
                  mat-stroked-button
                  (click)="retryJob(objectStatus)"
                  [disabled]="objectStatus.status !== 'failed' && objectStatus.status !== 'in progress' && objectStatus.status !== 'running'"
                >
                  {{ 'TRANS__JOB_STATUS__RETRY_OBJECT' | translate }}
                </button>

                <span>
                  <a
                    [queryParams]="objectStatus.ref?.queryParams"
                    [routerLink]="objectStatus.ref?.routerLink"
                  >
                    {{ objectStatus.artifact_name }}
                  </a>
                </span>

                <span>
                  {{ getStatusText(objectStatus.status) }}
                </span>

                @if (objectStatus.status_message) {
                  <span>
                    - {{ objectStatus.status_message  | translate }}
                  </span>
                }
              </div>
            }

            <!-- Show previous objects -->
            @if (detailsStartIndex > 0) {
              <button
                mat-stroked-button
                (click)="showPreviousObjects()"
              >
                {{ 'TRANS__JOB_STATUS__SHOW_PREVIOUS_OBJECTS' | translate }}
              </button>
            }
            <!-- If more than displayRows are present, show a button to view next objects -->
            @if (message.details.object_count > detailsStartIndex + detailsRows) {
              <button
                mat-stroked-button
                (click)="showNextObjects()"
              >
                {{ 'TRANS__JOB_STATUS__SHOW_NEXT_OBJECTS' | translate }}
              </button>
            }
          }
          @else if (jobErrorDetail()) {
            <div class="job-item__details-content">
              <span>
                {{ jobErrorDetail() }}
              </span>
            </div>
          }
          @else {
            <div class="job-item__details-content">
              <span>
                {{ 'TRANS__JOB_STATUS__NOT_DETAILS_AVAILABLE' | translate }}
              </span>
            </div>
          }
        </div>
      }
    }
    @else {
      <div class="job-item__id-button-container">
      <span class="job-item__body-id">
        ID: {{ message.queue_id }}
      </span>
      </div>
    }
  </div>
</mat-expansion-panel>
